import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import { IntlContext } from "context";
import Form, { Mode } from "../Form";
import { useService } from "hooks/service";
import { SUBCATEGORY_TO_CATEGORY, SubCategory } from "types/subCategory";
import { ROUTES } from "routes";
import { Loader } from "ui/Loader";
import { getCategoryStyle } from "../categoryStyle";

const ServiceEditPage: React.FC = () => {
    const intl = useContext(IntlContext);
    const { id } = useParams();
    const { data, isLoading } = useService(id);

    if (isLoading || !data) {
        return <Loader />;
    }

    const categoryKey = data.category.toString();
    const { Icon, boxClass, iconClass } = getCategoryStyle(categoryKey);
    const subCategory = data.subcategory as SubCategory | undefined;

    const categoryLabel = intl.formatMessage(`category.${categoryKey.toLocaleLowerCase()}`);
    const serviceTitle = subCategory
        ? intl.formatMessage(
              `subcategory.${SUBCATEGORY_TO_CATEGORY[subCategory].toLocaleLowerCase()}.${subCategory.toLocaleLowerCase()}.label`
          )
        : categoryLabel;

    const addedOnLabel = intl.formatMessage("service.edit.subtitle", {
        date: moment(data.created_at).format("DD/MM/YYYY"),
    });

    return (
        <div className="space-y-6">
            <Link
                to={ROUTES.MY_SERVICES}
                className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-primary"
            >
                <ArrowLeft className="h-4 w-4" strokeWidth={2.25} />
                Retour à mes services
            </Link>

            <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
                <header className="border-b border-gray-100 pb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Modifier un service</h2>
                    <p className="mt-1 text-sm text-slate-500">{addedOnLabel}</p>

                    <div className="mt-5 flex items-start gap-4">
                        <div
                            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${boxClass}`}
                        >
                            <Icon className={`h-5 w-5 ${iconClass}`} strokeWidth={2} />
                        </div>
                        <div className="min-w-0">
                            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                                {categoryLabel}
                            </p>
                            <p className="mt-0.5 text-lg font-bold text-gray-900">{serviceTitle}</p>
                        </div>
                    </div>
                </header>

                <div className="service-form-profile mt-8">
                    <Form initialValues={data} mode={Mode.EDIT} />
                </div>
            </div>
        </div>
    );
};

export default ServiceEditPage;
